import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const BEElectronicsEngineeringCoursePage: React.FC = () => {
  const courseData = {
    title: "B.E. Electronics Engineering",
    shortName: "B.E. Electronics",
    duration: "4 Years",
    description: "Study electronic circuits, devices, embedded systems, and communication technology.",
    overview: "Bachelor of Engineering in Electronics Engineering is a 4-year undergraduate program focused on electronic devices, circuit design, embedded systems, signal processing, and communication technologies. The course prepares students for careers in electronics, embedded systems, and R&D.",
    eligibility: [
      "10+2 with Physics, Chemistry, Mathematics",
      "Valid entrance exam score (JEE Main/State CET)",
      "Interest in electronics and technology"
    ],
    curriculum: [
      {
        year: 1,
        subjects: [
          "Mathematics-I & II",
          "Physics",
          "Chemistry",
          "Basic Electronics",
          "Engineering Graphics",
          "Introduction to Electronics"
        ]
      },
      {
        year: 2,
        subjects: [
          "Digital Electronics",
          "Analog Electronics",
          "Electronic Circuits",
          "Signals and Systems",
          "Microprocessors",
          "Electromagnetic Fields"
        ]
      },
      {
        year: 3,
        subjects: [
          "Embedded Systems",
          "VLSI Design",
          "Communication Systems",
          "Control Systems",
          "Power Electronics",
          "Instrumentation"
        ]
      },
      {
        year: 4,
        subjects: [
          "Advanced Electronics",
          "Nanoelectronics",
          "Project Work/Internship",
          "Research Seminar"
        ]
      }
    ],
    careerProspects: {
      roles: [
        "Electronics Engineer",
        "Embedded Systems Engineer",
        "VLSI Design Engineer",
        "R&D Engineer",
        "System Designer",
        "Test Engineer"
      ],
      industries: [
        "Electronics Manufacturing",
        "Semiconductor Companies",
        "Embedded Systems",
        "Telecom",
        "IT Hardware",
        "Research Organizations"
      ],
      averageSalary: "₹3-8 LPA (Fresher), ₹10-20 LPA (Experienced)",
      topRecruiters: [
        "Intel",
        "Texas Instruments",
        "Samsung",
        "Bosch",
        "L&T",
        "DRDO",
        "ISRO"
      ]
    },
    admissionProcess: [
      "JEE Main/State CET",
      "Counseling and seat allocation",
      "Direct admission based on 12th marks (in some colleges)"
    ],
    topColleges: [
      {
        name: "IIT Madras",
        location: "Chennai",
        fees: "₹8,00,000",
        ranking: "NIRF Ranking: 1"
      },
      {
        name: "NIT Trichy",
        location: "Trichy",
        fees: "₹5,00,000",
        ranking: "NIRF Ranking: 8"
      },
      {
        name: "College of Engineering Guindy, Anna University",
        location: "Chennai",
        fees: "₹2,00,000",
        ranking: "NIRF Ranking: 35"
      }
    ],
    skills: [
      "Circuit Design",
      "Embedded Systems",
      "VLSI Design",
      "Signal Processing",
      "Programming (C/C++/HDL)",
      "Project Management"
    ],
    futureScope: "Excellent opportunities in electronics, embedded systems, IoT, VLSI, and research. High demand in manufacturing, R&D, and hardware startups.",
    faqs: [
      {
        question: "Is Electronics Engineering good for VLSI careers?",
        answer: "Yes, it provides strong fundamentals for VLSI, chip design, and embedded systems."
      },
      {
        question: "Is coding required?",
        answer: "Yes, especially for embedded systems and hardware description languages."
      },
      {
        question: "Can I work in IT after this course?",
        answer: "Yes, electronics engineers are recruited in IT hardware, embedded software, and system design roles."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow mb-6 text-center animate-glow">
        {courseData.title}
      </h1>
      <div className="w-full max-w-4xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BEElectronicsEngineeringCoursePage;
